import { useEffect, useState } from "react";

export default function Footer() {
  const [dateTime, setDateTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setDateTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  return (
    <>
      <footer class="p-2 border-t border-green-700 bg-black text-xs text-green-500 font-mono flex justify-between items-center">
        <span>akshayiscoding@portfolio:~$</span>
        <span>
          {dateTime.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: true,
          })}
        </span>
      </footer>
    </>
  )
}